import type { MultiFactor as MultiFactorModel } from '@/adapters/catalogv1.g';

export function extractMultiFactor(model: MultiFactorModel) {
  return {
    id: model._metadata?.distinct_id ?? '',
    ref: model.multi_factor_ref ?? '',
    kind: model.kind,
    orgPolicy: model.org_policy,
    tenantId: model._metadata?.tenant_id,
    connectorId: model._metadata?.segment_id,
  };
}

export type CatalogMultiFactor = ReturnType<typeof extractMultiFactor>;
